authTimeoutRun.$inject = ['$rootScope', 'AUTH_EVENTS', 'AuthTimeoutService'];

export default function authTimeoutRun($rootScope, AUTH_EVENTS, AuthTimeoutService) {
    $rootScope.$on(AUTH_EVENTS.LOGIN_SUCCESS, AuthTimeoutService.startTimeout); // Fired by: AuthService
    $rootScope.$on(AUTH_EVENTS.LOGOUT_SUCCESS, AuthTimeoutService.stopTimeout); // Fired by: AuthService
    $rootScope.$on(AUTH_EVENTS.RESET_TIMEOUT, AuthTimeoutService.resetTimeout); // Fired by: AuthInterceptor
    $rootScope.$on(AUTH_EVENTS.LOCK_APP, AuthTimeoutService.lockApp); // Fired by: AuthInterceptor
}
